import { IShopItem } from '~/src/api/content/shop/getShopItems';
import type { ELocation } from '~/src/features/videocontrol/data';
import { TYPE_OF_BUY } from '~/src/features/videocontrol/pageBlocks/StepsInstall/CameraCard/constants';
import type { PriceOptionProps } from '~/src/features/videocontrol/pageBlocks/StepsInstall/CameraCard/types';
import type { TCamera } from '~/src/features/videocontrol/Provider/types';

export const getPayload = (options: PriceOptionProps, product: IShopItem, activeTabLocation?: ELocation): TCamera => {
    const { name, selectedOption: { label, operType, price } } = options;
    return {
        name,
        id: product.id,
        service: label,
        count: 1,
        operType: operType === TYPE_OF_BUY.leasing.name ? TYPE_OF_BUY.leasing.value : TYPE_OF_BUY.possess.value,
        priceTotal: operType === TYPE_OF_BUY.possess.name ? price : null,
        priceMonth: operType === TYPE_OF_BUY.leasing.name ? price : null,
        currencyType: operType === TYPE_OF_BUY.possess.name ? TYPE_OF_BUY.rub : TYPE_OF_BUY.rubMonth,
        location: activeTabLocation as ELocation,
        priceTotalWithCount: operType === TYPE_OF_BUY.possess.name ? price : 0,
        priceMonthWithCount: operType === TYPE_OF_BUY.leasing.name ? price : 0,
    };
};
